import { BaseModel } from './BaseInterface';
export const StrategyTypeBase: BaseModel[] = [
  {
    key: 'Core',
    userInput: 'Core',
    apiValue: 5,
    dbValue: 5,
    isCashVested: false
  },
  {
    key: 'Income',
    userInput: 'Income',
    apiValue: 6,
    dbValue: 6,
    isCashVested: false
  },
  {
    key: 'TaxOptimized',
    userInput: 'Tax Optimized',
    apiValue: 7,
    dbValue: 7,
    isCashVested: false
  },
  {
    key: 'CashEnhancedCore',
    userInput: 'Core',
    apiValue: 8,
    dbValue: 8,
    isCashVested: true
  },
  {
    key: 'CashEnhancedIncome',
    userInput: 'Income',
    apiValue: 9,
    dbValue: 9,
    isCashVested: true
  },
  {
    key: 'CashEnhancedTaxOptimized',
    userInput: 'Tax Optimized',
    apiValue: 10,
    dbValue: 10,
    isCashVested: true
  },
  {
    key: 'SRI',
    userInput: 'Socially Responsible',
    apiValue: 11,
    dbValue: 11,
    isCashVested: false
  },
  {
    key: 'CashEnhancedSRI',
    userInput: 'Socially Responsible',
    apiValue: 12,
    dbValue: 12,
    isCashVested: true
  }
];
